import { useLocation, } from 'react-router-dom';
import { logout } from "./api/api";

const CheckUserInfoAgreement = () => {

    const { pathname } = useLocation();
    const agreement = localStorage.getItem("agreement") === "1" ? true : false;
    const isPb = localStorage.getItem("isPB") === "true" ? true : false;
    const isNewInquiryOrTopPage = ["/inquiry_create", "/inquiry_status"].includes(pathname) ? true : false;
    const infoCheck = ["", undefined, null, false];

    if (localStorage.length !== 0) {
        if (agreement !== true) {
            alert("サービスの利用が同意されてませんので再度ログインをお願いします。");
            logout();
            window.location.replace("/fcc_login");
            return;
        }
        if (isNewInquiryOrTopPage === true) {
            if (isPb === true) {

                let userInfoArr = JSON.parse(localStorage.getItem("userInfoStorage"));

                if (infoCheck.includes(userInfoArr.sei)
                    || infoCheck.includes(userInfoArr.mei)
                    || infoCheck.includes(userInfoArr.seiYomi)
                    || infoCheck.includes(userInfoArr.meiYomi)
                    || infoCheck.includes(userInfoArr.departmentName)
                    || infoCheck.includes(userInfoArr.telNo)) {
                    alert("ユーザー情報が不正なため再度ログインをお願いします。");
                    logout();
                    window.location.replace("/fcc_login");
                    return;

                }
                return;
            }
            return;
        }
        return;
    }

    return;
}

export default CheckUserInfoAgreement;